import { AxleFieldNames } from '../order/fields/AxleInformationFields';
import { LoadInformationFieldNames } from '../order/fields/LoadInformationFields';
import { MobileHomeInformationFieldNames } from '../order/fields/MobileHomeInformationFields';
import { OverallDimensionsInformationFieldNames } from '../order/fields/OverallDimensionsInformationFields';
import { TractorFieldNames } from '../order/fields/TractorInformationFields';
import { TrailerFieldNames } from '../order/fields/TrailerInformationFields';
import { TripInformationFieldNames } from '../order/fields/TripInformationFields';

export const DIMENSION_FIELDS: string[] = [
  OverallDimensionsInformationFieldNames.OverallLength,
  OverallDimensionsInformationFieldNames.OverallHeight,
  OverallDimensionsInformationFieldNames.OverallWidth,
  OverallDimensionsInformationFieldNames.OverallFrontOverhang,
  OverallDimensionsInformationFieldNames.OverallRearOverhang,
  OverallDimensionsInformationFieldNames.OverallEFFOverhang,
  TractorFieldNames.TractorWidth,
  TractorFieldNames.TractorHeight,
  TractorFieldNames.TractorLength,
  TractorFieldNames.TractorWheelBase,
  TractorFieldNames.TractorGroundHeight,
  LoadInformationFieldNames.LoadWidth,
  LoadInformationFieldNames.LoadHeight,
  LoadInformationFieldNames.LoadLength,
  TrailerFieldNames.TrailerLength,
  TrailerFieldNames.TrailerWidth,
  TrailerFieldNames.TrailerHeight,
  TrailerFieldNames.TrailerWheelbaseLength,
  TrailerFieldNames.TrailerDeckHeight,
  TrailerFieldNames.TrailerGroundClearance,
  TrailerFieldNames.TrailerKingpinSetbackLength,
  TrailerFieldNames.TrailerKingpinSettingLength,
  TractorFieldNames.TractorOuterBridgeLength,
  AxleFieldNames.AxleWidth,
  AxleFieldNames.AxleSpacing,
  MobileHomeInformationFieldNames.MobileHomeHitchLength,
  MobileHomeInformationFieldNames.MobileHomeEaveWidth,
  MobileHomeInformationFieldNames.MobileHomeBoxWidth,
  MobileHomeInformationFieldNames.MobileHomeBoxLength,
  MobileHomeInformationFieldNames.MobileHomeRoadsideEavesLength,
  MobileHomeInformationFieldNames.MobileHomeCurbsideEavesLength,
];

export const WEIGHT_FIELDS: string[] = [
  OverallDimensionsInformationFieldNames.OverallWeight,
  TractorFieldNames.TractorUnladenWeight,
  TractorFieldNames.TractorActualWeight,
  LoadInformationFieldNames.LoadWeight,
  TrailerFieldNames.TrailerEmptyWeight,
  TrailerFieldNames.TrailerRegisteredWeight,
  TripInformationFieldNames.TripBaseRegisteredWeight,
  AxleFieldNames.AxleWeight,
  AxleFieldNames.AxleCapacity,
  AxleFieldNames.TireRating,
];
